module.exports = __webpack_public_path__ + "img/Card_Avoid_Blue-min.00c753d4.png";